import { type Editor } from '@tiptap/react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewport } from '@/hooks';
import { UnderlineIcon } from '@/icons';
import { Tooltip } from '@/ui_v3';
import { IconButton } from '@/ui_v3/components/button';
import { cn } from '@/utils';
import { useMark } from './useMark';
export const UnderlineButton = ({
  editor
}: {
  editor: Editor | null;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    handleMark,
    isActive
  } = useMark({
    editor,
    type: 'underline'
  });
  const {
    isMobile
  } = useViewport();
  return <Tooltip.Provider disableHoverableContent={isMobile} data-sentry-element="unknown" data-sentry-component="UnderlineButton" data-sentry-source-file="UnderlineButton.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="UnderlineButton.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="UnderlineButton.tsx">
          <IconButton className={cn(isActive && 'bg-gray-200')} variant="transparent" intent="neutral" size="xs" onMouseDown={e => {
          e.preventDefault(); // Prevent focus loss
        }} onClick={() => {
          handleMark();
          logger.track('build_addunderline');
        }} data-sentry-element="IconButton" data-sentry-source-file="UnderlineButton.tsx">
            <UnderlineIcon size="xs" fill={isActive ? ICON_COLOR.strong : ICON_COLOR.default} data-sentry-element="UnderlineIcon" data-sentry-source-file="UnderlineButton.tsx" />
          </IconButton>
        </Tooltip.Trigger>
        <Tooltip.Content data-sentry-element="unknown" data-sentry-source-file="UnderlineButton.tsx">{t('build.textEditor.underline')}</Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};